'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPhoneForwarded = function NotificationPhoneForwarded(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
  );
};
NotificationPhoneForwarded = (0, _pure2.default)(NotificationPhoneForwarded);
NotificationPhoneForwarded.displayName = 'NotificationPhoneForwarded';
NotificationPhoneForwarded.muiName = 'SvgIcon';

exports.default = NotificationPhoneForwarded;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/notification/phone-forwarded.js
 ** module id = 2293
 ** module chunks = 0
 **/